import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../../theme';
import { FormTheme } from '../../styles/formThemeConstants';
import { textAfter } from '../../styles/mixins';

const SMALL_LABEL_FONT_SIZE = 11;
const VALUE_FROM_TOP_BASE = SMALL_LABEL_FONT_SIZE + ThemeSpaces.SPACE_XS + 2;

const labelStyle = token => ({
  fontSize: token.fontSize,
  color: ThemeColors.COLOR_GREY_BLUISH,
  lineHeight: 1,
});

export const useFormItemStyles = createStyles(({ token }) => ({
  floatingLabelWrapper: {
    position: 'relative',

    '> label': {
      pointerEvents: 'none',
      position: 'absolute',
      left: ThemeSpaces.SPACE_MD,
      top: '50%',
      ...labelStyle(token),
      transform: 'translateY(-50%)',
      transition: 'all 0.25s ease-out',
    },
    '> .has-prefix + label': {
      left: ThemeSpaces.SPACE_NORM_50 + ThemeSpaces.SPACE_NORM0_5,
    },

    '&.is-required > label::after': {
      ...textAfter('*'),
      '.ant-form-hide-required-mark &': {
        content: 'none',
      },
    },
    '&.is-required > .qol-input-view-mode + label::after': {
      content: 'none',
    },

    '&.is-disabled > label': {
      opacity: 0.5,
    },

    '&.is-focused > label, &.has-value > label, > .ant-select-focused + label, > .ant-picker-focused + label':
      {
        fontSize: SMALL_LABEL_FONT_SIZE,
        top: ThemeSpaces.SPACE_XS + 2,
        transform: 'none',
      },

    '&.is-focused, &.has-value, > .ant-select-focused, > .ant-picker-focused': {
      '.ant-picker > .ant-picker-input > .ant-picker-suffix': {
        display: 'block',
      },
    },

    '> input, > .ant-input-affix-wrapper > input.ant-input': {
      lineHeight: 1,
      paddingTop: VALUE_FROM_TOP_BASE,
      paddingBottom: token.paddingXS,
      paddingLeft: token.paddingMD,
      paddingRight: token.paddingMD,
      fontWeight: 500,
    },
    '> .ant-input-affix-wrapper.has-prefix > input.ant-input': {
      paddingLeft: 0,
      fontWeight: 500,
    },

    '> .ant-input-number > * > input': {
      fontWeight: 500,
      lineHeight: 1,
      paddingTop: VALUE_FROM_TOP_BASE,
      paddingBottom: token.paddingXS,
      paddingLeft: token.paddingMD - 1,
      paddingRight: token.paddingMD,
    },

    '.ant-select .ant-select-selector, .ant-select.ant-select-single.ant-select-lg .ant-select-selector':
      {
        paddingTop: VALUE_FROM_TOP_BASE,
        paddingBottom: token.paddingXS,
        paddingLeft: token.paddingMD,
        paddingRight: token.paddingMD,

        '.ant-select-selection-item': {
          display: 'initial',
        },

        '.ant-select-selection-placeholder, .ant-select-selection-item': {
          paddingBottom: token.paddingXS,
          marginBottom: -token.marginXXS,
          marginTop: 1,
        },

        '&, .ant-select-selection-placeholder, .ant-select-selection-item': {
          lineHeight: 1,

          '&::after': {
            lineHeight: 1,
          },
        },
      },

    '.ant-picker': {
      '&.suffix-as-prefix .ant-picker-input': {
        '.ant-picker-suffix': {
          marginLeft: 0,
          marginRight: ThemeSpaces.SPACE_NORM0_5,
        },
      },
      '.ant-picker-input': {
        paddingTop: VALUE_FROM_TOP_BASE + 2,
        paddingBottom: token.paddingXS,
        paddingLeft: token.paddingMD,
        paddingRight: token.paddingMD,

        '> input': {
          padding: 0,
        },

        '.ant-picker-suffix': {
          display: 'none',
          '.fas, .far, .fal': {
            fontSize: 16,
          },
        },
      },
    },

    '.ant-input-affix-wrapper': {
      '> .ant-input-prefix': {
        marginLeft: 0,
        marginRight: '5px',
        width: ThemeSpaces.SPACE_NORM_50,
        height: '100%',
        fontSize: '14px',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        borderRight: `1px solid ${ThemeColors.COLOR_GREY9_5}`,
      },

      '> .ant-input-suffix': {
        marginLeft: 0,
        textAlign: 'right',
      },
    },
    [`.${FormTheme.DarkSimple} &,
      .${FormTheme.DarkOrange} &,
      .${FormTheme.DarkOrangeSimple} &
    `]: {
      '> .qol-input-view-mode + label': {
        color: ThemeColors.COLOR_GREY_BLUISH3,
        opacity: 1,
      },
    },
  },
}));
